import React, { Suspense } from 'react';
import type { WorkflowGraphNodeFlowRenderProps } from './types';
import { ToolCallFlowAffordances } from '../components/node/tool-call-flow-affordances';

const LazyAgentNodeCard = React.lazy(() =>
  import('../components/node/agent-node-card').then((mod) => ({
    default: mod.AgentNodeCard,
  }))
);

const LazyForEachNodeCard = React.lazy(() =>
  import('../components/node/strategies/for-each.node-strategy').then(
    (mod) => ({
      default: mod.ForEachNodeCard,
    })
  )
);

export function renderAgentFlowNode(
  props: WorkflowGraphNodeFlowRenderProps
): React.ReactNode {
  return (
    <Suspense fallback={null}>
      <LazyAgentNodeCard {...props} />
    </Suspense>
  );
}

export function renderForEachFlowNode(
  props: WorkflowGraphNodeFlowRenderProps
): React.ReactNode {
  return (
    <Suspense fallback={null}>
      <LazyForEachNodeCard {...props} />
    </Suspense>
  );
}

export function renderToolCallFlowAffordances(
  props: WorkflowGraphNodeFlowRenderProps
): React.ReactNode {
  return <ToolCallFlowAffordances {...props} />;
}
